// ANGULAR
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// GUARDS
import { AuthBusinessGuard } from '../core/guards/auth-business.guard';
import { AuthGuard } from '../core/guards/auth.guard';
import { SigninGuard } from '../core/guards/signin.guard';

// CONSTANTS
import { ROUTE_CONSTANTS } from '../constants/route';

const routes: Routes = [
  {
    path: ROUTE_CONSTANTS.CONTAINER.AUTH,
    loadChildren: () => import('./main/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [SigninGuard],
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.MAIN,
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
    canActivate: [AuthBusinessGuard],
  },
  {
    path: ROUTE_CONSTANTS.CONTAINER.ERROR,
    loadChildren: () => import('../@metronic/views/theme/content/error-page/error-page.module').then((m) => m.ErrorPageModule),
  },
  { path: '', pathMatch: 'full', redirectTo: ROUTE_CONSTANTS.CONTAINER.AUTH },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    CommonModule,
  ],
  exports: [RouterModule],
})
export class UiModulesRouting { }
